// extracted by mini-css-extract-plugin
module.exports = {"crm":"_747570b"};